export var euiFontWeightLight = 300
export var euiFontWeightRegular = 400
export var euiFontWeightMedium = 500
export var euiFontWeightSemiBold = 600
export var euiFontWeightBold = 700
export var euiCodeFontWeightRegular = 400
export var euiCodeFontWeightBold = 700
export default {"euiFontWeightLight":300,"euiFontWeightRegular":400,"euiFontWeightMedium":500,"euiFontWeightSemiBold":600,"euiFontWeightBold":700,"euiCodeFontWeightRegular":400,"euiCodeFontWeightBold":700}
